import React from "react";
import { useFetcher } from "react-router-dom";
import { useFetcherBusy } from "~/hooks/useRouteActivity";
import { FormattedLeaseData } from "~/types/lease";
import { INTENTS } from "~/utils";

export const useLeaseDetails = () => {
  const [showDeleteConfirm, setShowDeleteConfirm] = React.useState(false);
  const [showLeaseModal, setShowLeaseModal] = React.useState(false);
  const [showTerminateConfirm, setShowTerminateConfirm] = React.useState(false);
  const [modalLeaseDetails, setModalLeaseDetails] =
    React.useState<FormattedLeaseData>();

  const fetcher = useFetcher();
  const isLoading = useFetcherBusy(fetcher);

  const toggleTerminateConfirm = () =>
    setShowTerminateConfirm(!showTerminateConfirm);
  const toggleDeleteConfirm = () => setShowDeleteConfirm(!showDeleteConfirm);
  const toggleLeaseModal = () => setShowLeaseModal(!showLeaseModal);

  // const leaseFiles = useGetLeaseDetailsFiles({leaseID: })

  const handleLeaseTerminate = (endDate: string) => {
    const formValues = {
      leaseID: modalLeaseDetails?.leaseInfo?.id,
      endDate,
      status: "Terminating",
      _version: modalLeaseDetails?.leaseInfo?._version,
    };
    fetcher.submit(
      { intent: INTENTS._terminate_lease, body: JSON.stringify(formValues) },
      { method: "post" }
    );
    toggleLeaseModal();
  };

  const handleLeaseDelete = () => {
    fetcher.submit(
      {
        intent: INTENTS._delete_lease,
        body: JSON.stringify({
          id: modalLeaseDetails?.leaseInfo?.id || "",
          _version: modalLeaseDetails?.leaseInfo?._version,
        }),
      },
      { method: "post" }
    );
    toggleLeaseModal();
  };

  const onLeaseClick = (lease: any) => {
    setModalLeaseDetails(lease);
    toggleLeaseModal();
  };

  const currentDate = new Date();
  const startDate = new Date(
    (modalLeaseDetails?.leaseInfo.startDate || "").toString() || ""
  );
  const isActive = startDate.getTime() < currentDate.getTime();

  return {
    showDeleteConfirm,
    showTerminateConfirm,
    isLoading,
    isActive,
    isTerminated:
      modalLeaseDetails?.leaseInfo?.status === "Expired" ||
      modalLeaseDetails?.leaseInfo?.status === "Terminated" ||
      modalLeaseDetails?.leaseInfo?.status === "Terminating",
    modalLeaseDetails,
    showLeaseModal,
    onLeaseClick,
    toggleLeaseModal,
    toggleDeleteConfirm,
    setModalLeaseDetails,
    handleLeaseTerminate,
    toggleTerminateConfirm,
    handleLeaseDelete,
  };
};
